// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  mapApiKey: 'AIzaSyAYgPwBdqSnnsxfjEI7F763kMh6KEyw9EM',
  baseUrl: 'https://api.yumzy.ai/suggestionv2',
  // baseUrl: 'https://api.dev.yumzy.ai/suggestionv2',
  analyticsUrl: 'https://analytics.yumzy.in',
  googleMapUrl: 'https://maps.googleapis.com',
  paymentBaseUrl :'',
  termsAndConditionsUrl: 'https://yumzyx.com/privacy-policy',
  RAZOR_PAY_KEY: 'rzp_live_yK1mfdeCZXuLDy', // Production
  APPSFLYER_DEV_KEY: '8fgba3qyvssLWYT3u6LvB5', // Production  
  APPLE_APP_ID: '1476665049', // Production
  firebaseConfig: {
    apiKey: "AIzaSyAax3HIru-vx5TIfnNmtV3cQG1MTWK51Xc",
    authDomain: "yumzy-de919.firebaseapp.com",
    databaseURL: "https://yumzy-de919.firebaseio.com",
    projectId: "yumzy-de919",
    storageBucket: "yumzy-de919.appspot.com",
    messagingSenderId: "602389669138",
    appId: "1:602389669138:web:af9e13badc75b1e88a3fcb",
    measurementId: "G-HYV6Y6ZVYS"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.


// export const environment = {
//   production: false,
//   mapApiKey: 'AIzaSyAu7d9alua551hRqOmLLFd3sz4Kk2bORak',
//   baseUrl: 'https://api.dev.yumzy.ai/suggestionv2',
//   analyticsUrl: 'https://dev.analytics.yumzy.in',
//   googleMapUrl: 'https://maps.googleapis.com',
//   paymentBaseUrl :'https://common.laalsa.com/paymentco',
//   termsAndConditionsUrl: 'https://yumzyx.com/privacy-policy',
//   RAZOR_PAY_KEY: 'rzp_test_L9afSYwM9TfHhI', // Testing
//   firebaseConfig: {
//     apiKey: "AIzaSyCB_x7FW7uc9OFUaLa2w9R_dsANNXNcK-o",
//     authDomain: "yumzy-dev.firebaseapp.com",
//     databaseURL: "https://yumzy-dev.firebaseio.com",
//     projectId: "yumzy-dev",
//     storageBucket: "yumzy-dev.appspot.com",
//     messagingSenderId: "483512165996",
//     appId: "1:483512165996:web:27e24e93396d44356dda49",
//     measurementId: "G-6JB3XW7WS4"
//   }
// }

